export const panoStartLatLon = state => state.getIn(['panorama', 'panoStartLatLon'])
